const ratingValues = [
  {
    value: '1',
    text: '1'
  },
  {
    value: '2',
    text: '2'
  },
  {
    value: '3',
    text: '3'
  },
  {
    value: '4',
    text: '4'
  },
  {
    value: '5',
    text: '5'
  },
  {
    value: '6',
    text: '6'
  },
  {
    value: '7',
    text: '7'
  },
  {
    value: '8',
    text: '8'
  },
  {
    value: '9',
    text: '9'
  }
];

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida estas afirmaciones te representan utilizando la siguiente escala:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'PARTNER_PAGE_01',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01',
          html: `
  <div class="QuestionText BorderColor">
    <span style="font-size:16px;">
      <span style="font-family:arial,helvetica,sans-serif;">
        <h3>Instrucciones</h3>
      </span>
      <br />
      A continuación encontrarás una lista de afirmaciones sobre cosas que las personas hacen, sienten o piensan en relación a su elección de carrera.
      <br />
      <br />
      Por favor indica en qué medida estas afirmaciones te representan usando una escala de <strong>1</strong> (No me representa para nada) a <strong>9</strong> (Me representa muy bien), tal como se presenta a continuación:
      <br />
      <br />
      <div class="qstn-likert-label top">
        <div>No me representa para nada</div>
      </div>
      <div class="btn-group">
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>1</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>2</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>3</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>4</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>5</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="6" value="6"><span class="quanta_q_rating_item_text"><span>6</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="7" value="7"><span class="quanta_q_rating_item_text"><span>7</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="8" value="8"><span class="quanta_q_rating_item_text"><span>8</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="SCCI_00" aria-required="true" aria-label="9" value="9"><span class="quanta_q_rating_item_text"><span>9</span></span></label>
      </div>
      <div class="qstn-likert-label bottom">
        <div>Me representa muy bien</div>
      </div>
    </span>
  </div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  {
    code: 'SCCI_01',
    text:
      'La pregunta sobre qué hacer después de salir del colegio es una de las cosas sobre las que he estado pensando recientemente'
  },
  {
    code: 'SCCI_02',
    text:
      'Consulto con otras personas sobre los pasos que debería seguir para tomar una buena decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_03',
    text:
      'Para tomar una decisión sobre qué hacer después del colegio, he juntado información detallada sobre carreras, lugares de trabajo, oportunidades de desarrollo, y programas de estudio, entre otras cosas'
  },
  {
    code: 'SCCI_04',
    text:
      'Estoy posponiendo la decisión sobre qué hacer después de salir del colegio'
  },
  {
    code: 'SCCI_05',
    text:
      'Le pido ayuda a otros para reducir el estrés que implica tomar una decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_06',
    text:
      'Buscar información adicional (sobre carreras, puestos de trabajos, oportunidades de desarrollo, programas de estudio, y otros) me ayuda a reducir el estrés de tomar una decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_07',
    text:
      'Siento que NO tengo la fortaleza para enfrentar la incertidumbre que implica tomar una decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_08',
    text:
      'Le pido a otros que me digan que debería hacer después de salir del colegio'
  },
  {
    code: 'SCCI_09',
    text:
      'Cuando pienso sobre qué haré después del colegio, evalúo las ventajas y desventajas de cada una de las opciones que estoy considerando'
  },
  {
    code: 'SCCI_10',
    text:
      'No quiero que otros sepan cómo me siento con respecto a lo que quiero hacer cuando salga del colegio'
  },
  {
    code: 'SCCI_11',
    text:
      'Cuando pienso en qué haré después del colegio, estoy dispuesto a dejar de lado algunas de mis preferencias porque reconozco las limitaciones de la realidad'
  },
  {
    code: 'SCCI_12',
    text:
      'Estoy constantemente preocupado de equivocarme y elegir una carrera inadecuada para mí'
  },
  {
    code: 'SCCI_13',
    text:
      'Mantengo la esperanza de que tomaré una buena decisión sobre qué hacer después del colegio (me digo a mi mismo/a "Yo puedo")'
  },
  {
    code: 'SCCI_14',
    text:
      'Estoy enojado con los que me rodean porque solo me hacen más difícil decidir qué hacer después del colegio'
  },
  {
    code: 'SCCI_15',
    text:
      'Soy capaz de manejar el estrés que implica tomar una decisión sobre mi futuro laboral'
  },
  {
    code: 'SCCI_16',
    text:
      'Para mí es importante elegir una carrera que se ajuste a mis intereses y habilidades'
  },
  {
    code: 'SCCI_17',
    text:
      'Consulto con otras personas cómo hacer realidad lo que quiero de mi futuro laboral'
  },
  {
    code: 'SCCI_18',
    text:
      'Para tomar una decisión informada sobre qué hacer después de la graduación busco información de distintas fuentes (descripciones de puestos de trabajo en Internet, hablo con personas de distintas empresas, entre otras cosas)'
  },
  {
    code: 'SCCI_19',
    text:
      'Estoy aplazando la decisión sobre qué hacer después de salir del colegio, con la esperanza de que el paso del tiempo lo haga más fácil'
  },
  {
    code: 'SCCI_20',
    text:
      'Le pido ayuda a otros sobre cómo aliviar mis preocupaciones sobre tener que tomar una decisión sobre mi futuro laboral'
  },
  {
    code: 'SCCI_21',
    text:
      'Buscar información adicional (sobre carreras, puestos de trabajos, oportunidades de desarrollo, programas de estudio, y otros) me ayuda a reducir mis preocupaciones sobre mi futuro laboral'
  },
  {
    code: 'SCCI_22',
    text:
      'Me siento desesperanzado cuando me enfrento a la pregunta sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_23',
    text: 'Le pregunto a otras personas qué carrera es adecuada para mí'
  },
  {
    code: 'SCCI_24',
    text:
      'Cuando pienso sobre qué haré después del colegio, pongo sobre la balanza qué aspectos son importante para mí (horarios de trabajo, flexibilidad, e ingresos, entre otros)'
  },
  {
    code: 'SCCI_25',
    text:
      'No quisiera que otros sepan cuán preocupado y ansioso me siento sobre lo que haré después de salir del colegio'
  },
  {
    code: 'SCCI_26',
    text:
      'Cuando pienso en qué haré después del colegio, estoy dispuesto a transar entre mis aspiraciones y lo que es factible en el mundo real'
  },
  {
    code: 'SCCI_27',
    text:
      'Estoy constantemente preocupado de que mis expectativas sobre mi futuro laboral no se cumplan'
  },
  {
    code: 'SCCI_28',
    text:
      'Me mantengo optimista sobre tomar una buena decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_29',
    text:
      'Me molestan los que están a mi alrededor porque siento que me hacen más difícil tomar una decisión sobre mi futuro laboral'
  },
  {
    code: 'SCCI_30',
    text:
      'Soy capaz de reducir la preocupación que implica tomar una decisión sobre mi futuro laboral'
  },
  {
    code: 'SCCI_31',
    text: 'No me molestaría si terminara eligiendo una carrera inadecuada'
  },
  {
    code: 'SCCI_32',
    text:
      'La pregunto a otros qué factores debería tomar en cuenta para decidir qué hacer después del colegio'
  },
  {
    code: 'SCCI_33',
    text:
      'Para tomar una decisión sobre qué hacer después del colegio, busco información relevante y actualizada sobre las carreras que estoy considerando'
  },
  {
    code: 'SCCI_34',
    text:
      'Me doy cuenta de que trato de evitar pensar sobre la decisión que tendré que tomar al salir del colegio'
  },
  {
    code: 'SCCI_35',
    text:
      'Le pido ayuda a otros para aliviar mis preocupaciones y mi frustración sobre tomar una decisión de carrera'
  },
  {
    code: 'SCCI_36',
    text:
      'Buscar información adicional (sobre carreras, puestos de trabajos, oportunidades de desarrollo, programas de estudio, y otros) me ayuda a sentirme menos ansioso sobre lo que haré después del colegio'
  },
  {
    code: 'SCCI_37',
    text:
      'Siento que NO puedo hacer frente a la complejidad de decidir qué hacer después del colegio'
  },
  {
    code: 'SCCI_38',
    text:
      'Le pido a otras personas que resuelvan la confusión que tengo sobre qué hacer después de salir del colegio'
  },
  {
    code: 'SCCI_39',
    text:
      'Cuando pienso sobre qué haré después del colegio, comparo mis opciones en términos de sus posibles resultados'
  },
  {
    code: 'SCCI_40',
    text:
      'No quisiera que otros supieran cuan duro es para mí tener que deliberar sobre qué hacer cuando salga del colegio'
  },
  {
    code: 'SCCI_41',
    text:
      'Cuando pienso en qué haré después del colegio, trato de encontrar un balance entre mis preferencias y los requerimientos del mundo real'
  },
  {
    code: 'SCCI_42',
    text:
      'Estoy constantemente preocupado sobre qué pasará si tomo una decisión sobre mi futuro laboral de la que me pueda arrepentir'
  },
  {
    code: 'SCCI_43',
    text:
      'Tengo una actitud positiva sobre el desafío de tomar una decisión de carrera'
  },
  {
    code: 'SCCI_44',
    text:
      'Siento que las personas que me rodean son responsables por lo difícil que ha sido para mí tomar una decisión sobre qué hacer después del colegio'
  },
  {
    code: 'SCCI_45',
    text:
      'Soy capaz de manejar mi ansiedad cuando ésta dificulta tomar una decisión sobre mi futuro laboral'
  }
];

const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  // showQuestionNumbers: 'off',
  requiredText: ``,
  pages: ITEMS.map((item, index) => {
    return {
      name: item.code,
      title: '',
      elements: [
        questionHeader,
        {
          type: 'rating',
          name: item.code,
          title: item.text,
          isRequired: true,
          minRateDescription: 'No me representa para nada',
          maxRateDescription: 'Me representa muy bien',
          rateValues: ratingValues
        }
      ]
    };
  })
};

export default baseInfo;
